import { yupResolver } from "@hookform/resolvers/yup";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  DialogContentText,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { useStoreActions, useStoreState } from "easy-peasy";
import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { pt } from "yup-locale-pt";
import {
  Checkbox,
  DialogoConfirmacao,
  DialogoConfirmacaoSimples,
  FileField,
  Select,
  AsyncAutocomplete,
  PropostaComercialSection,
  StepByStepPreDiagnostico2,
  Timestamps,
} from "../../components";
import api from "../../services/api";
import {
  getDocumentoAberturaLabel,
  isProgramaInovacao,
  isProgramaProcel,
} from "../../helpers/programa";

import {
  motivosPMENaoContratarDiagnostico,
  selecionarPMEVaiContratarDiagnostico,
  opcoesBooleanas,
  estadosBrasil,
} from '../../static';
import { UF_TODOS } from "../../config";
import is from "date-fns/locale/is";
import checkFinishReport from "../../store/checkFinishReport";
import { id } from "chartjs-plugin-autocolors";

yup.setLocale(pt);

const VisitaTecnica = () => {
  let user = useStoreState((state) => state.auth.user);

  const normalizarEstado = (estado) => {
    const valor = String(estado || "").trim().toUpperCase();
    const encontrado = estadosBrasil.find(
      (item) => item.sigla.toUpperCase() === valor || item.name.toUpperCase() === valor
    );
    return encontrado?.sigla || valor;
  };
  let finishReportGenerate = useStoreState((state) => state.checkFinishReport.finish)
  let currProcesso = useStoreState((state) => state.processo.current);
  const podeAprovarNoEstado =
    user.roleId === "superAdmin" ||
    (user.roleId === "gestorSENAI" &&
      Boolean(user.uf) &&
      Boolean(currProcesso?.estado) &&
      (user.uf.trim().toUpperCase() === UF_TODOS ||
        normalizarEstado(user.uf) === normalizarEstado(currProcesso.estado)));
  const programaInovacao = isProgramaInovacao(currProcesso?.programa);
  const isProcel = isProgramaProcel(currProcesso?.programa);
  const documentoLabel = getDocumentoAberturaLabel(currProcesso?.programa);
  const podeEditarObservacoes = programaInovacao && ["gestorGIZ", "superAdmin"].includes(user.roleId);
  let selectProcesso = useStoreActions((actions) => actions.processo.select);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let loading = useStoreState((state) => state.nav.loading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  const [listaTecnicos, setListaTecnicos] = React.useState([]);
  const [listaConsultores, setListaConsultores] = React.useState([]);
  const [listaScrumMasters, setListaScrumMasters] = React.useState([]);
  const [visitaTecnica, setVisitaTecnica] = React.useState(null);
  const [openIsUseGenerateReport, setOpenIsUseGenerateReport] = React.useState(false);
  //const [dataPreDiagnostico, setDataPreDiagnostico] = React.useState(null);
  //const [isChangeReportGenerate, setIsChangeReportGenerate] = React.useState(null);

  const [exibirScrumMaster, setExibirScrumMaster] = React.useState(true);

  const schema = yup
    .object({
      tecnicoId: yup.number().positive().nullable().label("Escolha um especialista técnico"),
      tecnicoVisitaId: yup.number().positive().nullable().label("Escolha um especialista de mercado"),
      sgtColaboradorId: yup.number().positive().nullable().label("Especialista técnico (SGT)"),
      sgtColaboradorNome: yup.string().nullable().label("Nome do especialista técnico (SGT)"),
      sgtColaboradorEmail: yup.string().nullable().label("E-mail do especialista técnico (SGT)"),
      sgtUnidadeId: yup.number().positive().nullable().label("Unidade operacional (SGT)"),
      sgtUnidadeNome: yup.string().nullable().label("Nome da unidade operacional (SGT)"),
      scrumMasterId: yup.number().positive().nullable().label("Escolha um Especialista Lider"),
      scrumNotApply: yup.number().nullable().label('Esse projeto possui um especialista líder alocado?'),
      preDiagnosticoId: yup
        .number()
        .positive()
        .nullable()
        .label(isProcel ? "Relatório de Pré-diagnóstico" : "Pré-diagnóstico"),
      pendenciasId: yup.number().positive().nullable().label("Pendências"),
      dreId: yup.number().nullable().label("DRE mais recente"),
      balancoId: yup.number().nullable().label("Balanço mais recente"),
      docsTecnicosField: yup
        .array()
        .label("Arraste documentos técnicos aqui ou clique"),
      faturasEnergiaField: yup
        .array()
        .label("Arraste 12 últimas faturas de energia elétrica"),
      faturasEnergeticosField: yup
        .array()
        .label("Arraste as faturas dos energéticos"),
      cartaoCnpjId: yup
        .number()
        .positive()
        .nullable()
        .label("Cartão do CNPJ"),
      certNegInssId: yup
        .number()
        .positive()
        .nullable()
        .label("CADIN"),
      certRegFgtsId: yup
        .number()
        .positive()
        .nullable()
        .label("CND/CPEN/CRP"),
      crfId: yup
        .number()
        .positive()
        .nullable()
        .label("CRF"),
      certNegDebtTrabId: yup
        .number()
        .positive()
        .nullable()
        .label(documentoLabel),
      // certNegDebtEstId: yup
      //   .number()
      //   .positive()
      //   .nullable()
      //   .label("Certidão negativa de débitos estaduais"),
      pendenciasSanadas: yup.boolean().label("Pendências sanadas"),
      relatorioId: yup.number().positive().nullable().label("Relatório"),
      observacoes: yup.string().nullable().label("Observações"),
      outrosDocsField: yup
        .array()
        .label("Arraste outros documentos aqui ou clique"),
      isUseGenerateReport: yup.boolean().nullable().label('Não utilizar o relatório gerado'),
      isReportDeliveredPME: yup.boolean().nullable().label('Pré-diagnóstico entregue para PME'),
      isContractedDiag: yup.number().nullable().label('Selecione se a PME vai contratar o Diagnóstico'),
      isPMENaoContratou: yup.number().nullable().label('Favor elencar o motivo da não contratação do Diagnóstico'),
    })
    .required();

  // console.log("finishReportGenerate: ", finishReportGenerate);

  const defaultValues = {
    tecnicoId: "",
    tecnicoVisitaId: "",
    sgtColaboradorId: null,
    sgtColaboradorNome: null,
    sgtColaboradorEmail: null,
    sgtUnidadeId: null,
    sgtUnidadeNome: null,
    preDiagnosticoId: null,
    pendenciasId: null,
    relatorioId: null,
    outrosDocsField: [],
    dreId: null,
    balancoId: null,
    cartaoCnpjId: null,
    certNegInssId: null,
    certRegFgtsId: null,
    crfId: null,
    certNegDebtTrabId: null,
    // certNegDebtEstId: null,
    isPMENaoContratou: 0,
    scrumNotApply: null,
    observacoes: "",
  };

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  const {
    handleSubmit,
    register,
    watch,
    reset,
    getValues,
    setValue,
    formState: { isDirty, isSubmitting },
  } = useFormRef;

  const scrumMasterId = watch("scrumMasterId");
  const tecnicoId = watch("tecnicoId");
  const tecnicoVisitaId = watch("tecnicoVisitaId");
  const sgtColaboradorId = watch("sgtColaboradorId");
  const sgtColaboradorNome = watch("sgtColaboradorNome");
  const sgtColaboradorEmail = watch("sgtColaboradorEmail");
  const [sgtUnidadeFiltro, setSgtUnidadeFiltro] = React.useState(null);
  const isPMENaoContratou = watch("isPMENaoContratou");
  const isContractedDiag = watch("isContractedDiag");
  const isUseGenerateReport = watch("isUseGenerateReport");
  const isReportDeliveredPME = watch("isReportDeliveredPME");
  const observacoesValue = watch("observacoes");

  const podeExibirApresentacaoPME = programaInovacao
    ? (visitaTecnica?.reportGenerate || finishReportGenerate) &&
      Boolean((visitaTecnica?.observacoes || observacoesValue)?.trim())
    : (visitaTecnica?.reportGenerate || finishReportGenerate);
  const [originalConsultor, setOriginalConsultor] = React.useState(null);
  const [originalConsultorVisita, setOriginalConsultorVisita] = React.useState(null);
  const [showWarningTecnico, setShowWarningTecnico] = React.useState(false);
  const [showWarningTecnicoVisita, setShowWarningTecnicoVisita] = React.useState(false);
  const scrumNotApply = watch("scrumNotApply");

  const [aprovando, setAprovando] = React.useState([]);
  const [confirmacaoMsg, setConfirmacaoMsg] = React.useState([]);

  const [isReadtoclose, setIsReadtoclose] = React.useState(0);

  const [isreportGenerate, setIsreportGenerate] = React.useState(false);

  // const [exibirScrumNotApply, setExibirScrumNotApply] = React.useState(0);

  const verificaPreenchimento = () => {
    let erros = [];

    if (isUseGenerateReport
    )
      if (!getValues("relatorioId")) erros.push("Inclusão de relatório");

    if (erros.length > 0)
      return (
        <React.Fragment>
          <DialogContentText>
            Ainda não foram realizadas as seguintes ações:
          </DialogContentText>
          <ul>
            {erros.map((erro, index) => (
              <li key={index}>
                <DialogContentText>{erro}</DialogContentText>
              </li>
            ))}
          </ul>
        </React.Fragment>
      );
    return "";
  };

  const aprova = async (data) => {
    if (isProcel) {
      try {
        const { data: propostaComercial } = await api.http.get(
          `/propostas-comerciais/${currProcesso.id}`
        );
        if (
          !propostaComercial ||
          propostaComercial.statusConformidade !== "aprovado" ||
          !propostaComercial.dataAceitacaoProposta
        ) {
          stopLoading({
            message:
              "Aprove a documentação da proposta comercial e informe a data de assinatura/aceitação antes de aprovar o pré-diagnóstico.",
            severity: "error",
          });
          return;
        }
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: "error",
        });
        return;
      }
    }

    setAprovando(true);
    setConfirmacaoMsg(
      <React.Fragment>
        {verificaPreenchimento()}
        <DialogContentText>
          Esta ação não pode ser desfeita. Tem certeza que deseja <b>aprovar</b>{" "}
          para o diagnóstico energético?
        </DialogContentText>
      </React.Fragment>
    );
    setOpenConfirmacao(true);
  };

  const recusa = () => {
    setAprovando(false);
    setConfirmacaoMsg(
      <React.Fragment>
        Esta ação não pode ser desfeita. Tem certeza que deseja <b>reprovar</b>{" "}
        para diagnóstico energético?
      </React.Fragment>
    );
    setOpenConfirmacao(true);
  };

  const desfazerRecusa = () => {
    setOpenConfirmaDesfRecusa(true);
  };

  const salva = async (data) => {
    // só vale pro salvar que inicia o pré-diagnóstico: se o corpo já estava na tela,
    // é uma edição e a pessoa não perde o lugar
    const corpoEstavaVisivel = exibeCorpo;

    startLoading();
    if (visitaTecnica?.reportGenerate
      && isContractedDiag === 2
      && (isPMENaoContratou === undefined || isPMENaoContratou === null || isPMENaoContratou === "")) {
      stopLoading({
        message: "Informe o motivo da não contratação do Diagnóstico",
        severity: "error",
      });
    }
    else {
      try {
        let retorno;
        if (data.id) {
          retorno = (await api.http.put("/visitas_tecnicas/" + data.id, data))
            .data;
        } else {
          console.log("salvar o scrum master ");
          retorno = (
            await api.http.post("/visitas_tecnicas", {
              ...data,
              processoId: currProcesso.id,
            })
          ).data;
        }

        stopLoading({ severity: "success" });
        if (retorno.visitaTecnica.isReadtoclose === 1) {
          setIsReadtoclose(1);
        };
        reset(retorno.visitaTecnica);
        setVisitaTecnica(retorno.visitaTecnica);
        setOriginalConsultor(listaConsultores.find(t => t.id === retorno.visitaTecnica.tecnicoId) || null);
        setOriginalConsultorVisita(listaTecnicos.find(t => t.id === retorno.visitaTecnica.tecnicoVisitaId) || null);
        selectProcesso(retorno.processo);
        if (!corpoEstavaVisivel) setRolarParaCorpo(true);
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: "error",
        });
        throw error;
      }
    }
  };

  const cancela = () => {
    reset();
  };

  const [openConfirmacao, setOpenConfirmacao] = React.useState(false);

  const onSimConfirma = async (data) => {
    setOpenConfirmacao(false);
    const confirmaData = {
      ...data,
      estagio: aprovando ? "preDiagAprovado" : "preDiagReprovado",
      sgtUnidadeId: sgtUnidadeFiltro?.id ?? currProcesso?.sgtUnidadeId ?? null,
      sgtUnidadeNome:
        sgtUnidadeFiltro?.abreviacao ??
        sgtUnidadeFiltro?.descricao ??
        currProcesso?.sgtUnidadeNome ??
        null,
    };
    startLoading();
    try {
      let post = (
        await api.http.put(
          "/visitas_tecnicas/" + visitaTecnica.id,
          confirmaData
        )
      ).data;

      if (post.visitaTecnica.isReadtoclose === 1) {
        setIsReadtoclose(1);
      };

      if (currProcesso) {
        setValue("scrumNotApply", currProcesso.scrumNotApply);
      }

      selectProcesso(post.processo);
      setVisitaTecnica(post.visitaTecnica); //TODO algo se perdendo por aqui que a tela atualiza o processo mas perde o pré-diagnóstico carregado até o próximo rebuild
      reset(post.visitaTecnica);
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };
  const onNaoConfirma = () => {
    setOpenConfirmacao(false);
  };

  const handleDownloadDeclaracao = async () => {
    const endpoint = programaInovacao
      ? "/download/ficha-abertura"
      : "/download/termo-implementacao";
    const filename = programaInovacao
      ? "FichaDeAbertura-PotencializeEE.xlsx"
      : "TermoDeImplementação-PotencializeMAF.docx";

    const response = await api.http.get(endpoint, {
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleFichaAberturaUploaded = async (arquivo) => {
    if (!programaInovacao || !arquivo?.id || !currProcesso?.id) return;

    await api.http.post(
      `/processos/${currProcesso.id}/notificar-ficha-abertura`,
      { arquivoId: arquivo.id }
    );
  };

  const [openConfirmaDesfRecusa, setOpenConfirmaDesfRecusa] =
    React.useState(false);

  const onConfirmaDesfRecusa = async (data) => {
    setOpenConfirmaDesfRecusa(false);
    const confirmaData = {
      estagio: "preDiagIniciado",
    };
    startLoading();
    try {
      let put = (
        await api.http.put(
          "/visitas_tecnicas/" + visitaTecnica.id,
          confirmaData
        )
      ).data;
      if (put.visitaTecnica.isReadtoclose === 1) {
        setIsReadtoclose(1);
      };
      selectProcesso(put.processo);
      reset(put.visitaTecnica);
      setVisitaTecnica(put.visitaTecnica);
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  const onNaoConfirmaDesfRecusa = () => {
    setOpenConfirmaDesfRecusa(false);
  };

  const reprocessarIntegracaoSgt = async () => {
    const confirmou = window.confirm(
      "Deseja tentar novamente o envio deste processo para o SGT?"
    );
    if (!confirmou) return;

    startLoading();
    try {
      const retorno = (
        await api.http.put(`/visitas_tecnicas/${visitaTecnica.id}`, {
          ...getValues(),
          estagio: "preDiagAprovado",
          reprocessarSgt: true,
          sgtUnidadeId: sgtUnidadeFiltro?.id ?? currProcesso?.sgtUnidadeId ?? null,
          sgtUnidadeNome:
            sgtUnidadeFiltro?.abreviacao ??
            sgtUnidadeFiltro?.descricao ??
            currProcesso?.sgtUnidadeNome ??
            null,
        })
      ).data;

      selectProcesso(retorno.processo);
      setVisitaTecnica(retorno.visitaTecnica);
      reset(retorno.visitaTecnica);
      stopLoading({
        message: "Integração com o SGT concluída com sucesso.",
        severity: "success",
      });
    } catch (error) {
      const resposta = error?.response?.data;
      if (resposta?.processo) selectProcesso(resposta.processo);
      if (resposta?.visitaTecnica) {
        setVisitaTecnica(resposta.visitaTecnica);
        reset(resposta.visitaTecnica);
      }
      stopLoading({
        message:
          resposta?.error ||
          "Não foi possível concluir a integração com o SGT.",
        severity: "error",
      });
    }
  };

  const disabledAlocacao = () => {

    if(["superAdmin", "gestorSENAI", "consultorEE", "consultorMercado", "apoioSENAI"].includes(user.roleId)
        && ["preDiagIniciado", "inicioAprovado"].includes(
          currProcesso.estagio
        )) {
        return false;
      }
      else
        if (0 === user.id) {
          return false;
        }
        else
          return true;
  };


  const disabled = () => {

    // console.log("estagio: ", currProcesso.estagio);

    if (!["preDiagIniciado", "inicioAprovado"].includes(currProcesso.estagio)
      && ["superAdmin"].includes(user.roleId)
    ) {
      return false;
    }

    if (!["preDiagIniciado", "inicioAprovado"].includes(
      currProcesso.estagio
    )) {
      console.log("entrou aqui linha 387");
      return true;
    }
    else {
      // console.log("entrou aqui linha 390");

      if (["scrumMaster", "superAdmin", "consultorEE", "gestorSENAI", "apoioSENAI", "consultorMercado"].includes(user.roleId)
        && ["preDiagIniciado", "inicioAprovado"].includes(currProcesso.estagio))
        return false;
      else
        return (
          (user.roleId !== "superAdmin" &&
            !["preDiagIniciado", "inicioAprovado"].includes(
              currProcesso.estagio
            )) ||
          ((user.roleId === "consultorEE" || user.roleId === "consultorMercado") &&
            currProcesso?.interlocutorMercadoId !== user.id &&
            (tecnicoId !== user.id || tecnicoVisitaId !== user.id)) ||
          ![
            "consultorEE",
            "consultorMercado",
            "gestorSENAI",
            "superAdmin",
            "validadorIndSENAI",
          ].includes(user.roleId)
        );
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (currProcesso.estagio !== "inicioAprovado") {
          let visitaTecnicaData = (
            await api.http.get("/visitas_tecnicas/" + currProcesso.id)
          ).data;
          if (visitaTecnicaData.isReadtoclose === 1) {
            setIsReadtoclose(1);
          };

          if (visitaTecnicaData.reportGenerate) {
            reset(visitaTecnicaData);
            setVisitaTecnica(visitaTecnicaData);
          };
          if (visitaTecnicaData.isReportDeliveredPME === 1) {
            setValue("isReportDeliveredPME", true);
          }
          else {
            setValue("isReportDeliveredPME", false);
          }
          if (visitaTecnicaData.isUseGenerateReport === 1) {

            setValue("isUseGenerateReport", true); 
          }
          else {
            setValue("isUseGenerateReport", false);
          }
        }
      } catch (error) {
        console.error('Erro ao buscar os dados:', error);
      }
    };

    const intervalId = setInterval(() => {
      if (!visitaTecnica.reportGenerate) {
        fetchData();
      } else {
        clearInterval(intervalId);
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [visitaTecnica]);

  const fetchSgtUnidades = React.useCallback(async (search, page) => {
    const { data } = await api.http.get("/sgt/unidades", {
      params: {
        search: search || undefined,
        estado: currProcesso?.estado || undefined,
        page: page || undefined,
      },
    });
    return data;
  }, [currProcesso?.estado]);

  React.useEffect(() => {
    if (!isProcel || !currProcesso?.estado || sgtUnidadeFiltro) return;

    // Prioriza a unidade já escolhida no cadastro de elegíveis (Processo.sgtUnidadeId)
    // - só cai no "auto-seleciona se tiver 1 resultado só" se não tiver nada salvo.
    if (currProcesso?.sgtUnidadeId) {
      setSgtUnidadeFiltro({ id: currProcesso.sgtUnidadeId, abreviacao: currProcesso.sgtUnidadeNome });
      return;
    }

    let active = true;
    fetchSgtUnidades(undefined, 1).then((resultado) => {
      if (active && resultado?.data?.length === 1 && !resultado.hasMore) {
        setSgtUnidadeFiltro(resultado.data[0]);
      }
    });
    return () => { active = false; };
  }, [isProcel, currProcesso?.estado, currProcesso?.sgtUnidadeId]);

  const fetchSgtColaboradores = React.useCallback(
    async (search, page) => {
      const { data } = await api.http.get("/sgt/colaboradores", {
        params: {
          idunidade: sgtUnidadeFiltro?.id,
          search: search || undefined,
          page: page || undefined,
        },
      });
      return data;
    },
    [sgtUnidadeFiltro]
  );

  React.useEffect(async () => {
    startLoading();
    try {
      const tecnicos = (
        await api.http.get("/users", {
          params: {
            roleId: ["consultorEE","consultorMercado"],
            programaId: currProcesso?.programaId || undefined,
            habilitado: true,
            ordenado_alfa: true,
          },
        })
      ).data;
      setListaTecnicos(tecnicos);
      setListaConsultores(tecnicos.filter((consultor) => consultor.roleId === "consultorEE"));

      setListaScrumMasters(
        (
          await api.http.get("/users", {
            params: {
              roleId: ["scrumMaster"],
              habilitado: true,
              ordenado_alfa: true,
            },
          })
        ).data
      );

      let visitaTecnicaData = (
        await api.http.get("/visitas_tecnicas/" + currProcesso.id)
      ).data;

      if (visitaTecnicaData.tecnicoId) {
        const originalConsultantData = (
          await api.http.get("/users", {
            params: {
              id: visitaTecnicaData.tecnicoId,
            },
          })
        ).data[0];
        setOriginalConsultor(originalConsultantData);
      }

      if (visitaTecnicaData.tecnicoVisitaId) {
        const originalConsultantVisitData = (
          await api.http.get("/users", {
            params: {
              id: visitaTecnicaData.tecnicoVisitaId,
            },
          })
        ).data[0];
        setOriginalConsultorVisita(originalConsultantVisitData);
      }

      //if(currProcesso.scrumNotApply === 1){
      setValue("scrumNotApply", currProcesso.scrumNotApply)
      //}

      setExibirScrumMaster(currProcesso.scrumNotApply === 1 ? false : true);


      if (currProcesso.estagio !== "inicioAprovado") {

        if (visitaTecnicaData.isUseGenerateReport === 1) {

          setValue("isUseGenerateReport", true);
        }
        else {
          setValue("isUseGenerateReport", false);
        }

        visitaTecnicaData.isReportDeliveredPME === 1 ? setValue("isReportDeliveredPME", true) : setValue("isReportDeliveredPME", false);
        if (visitaTecnicaData.isReadtoclose === 1) {
          if (visitaTecnicaData.isContractedDiag === 1) {
            setValue("isContractedDiag", 1);
          }
          else { setValue("isContractedDiag", 2); }
        }

        if (visitaTecnicaData.isReadtoclose === 1) {
          setIsReadtoclose(1);
        };
      }
      const isTecnicoStillValid = tecnicos.some(
        (t) => String(t.id) === String(visitaTecnicaData.tecnicoId)
      );

      const isTecnicoVisitaStillValid = tecnicos.some(
        (t) => String(t.id) === String(visitaTecnicaData.tecnicoVisitaId)
      );

      const estagioValido = ["inicioAprovado", "preDiagIniciado"].includes(currProcesso.estagio);
      setShowWarningTecnico(!isTecnicoStillValid && estagioValido);
      setShowWarningTecnicoVisita(!isTecnicoVisitaStillValid && estagioValido);
      reset(visitaTecnicaData);
      setVisitaTecnica(visitaTecnicaData);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
    }
  }, []);

  React.useEffect(async () => {
    startLoading();
    try {

      let visitaTecnicaData = (
        await api.http.get("/visitas_tecnicas/" + currProcesso.id)
      ).data;

      setValue("scrumNotApply", currProcesso.scrumNotApply)

      setExibirScrumMaster(currProcesso.scrumNotApply === 1 ? false : true);

      if (currProcesso.estagio !== "inicioAprovado") {

        if (visitaTecnicaData.isUseGenerateReport === 1) {

          setValue("isUseGenerateReport", true);
        }
        else {
          setValue("isUseGenerateReport", false);
        }

        visitaTecnicaData.isReportDeliveredPME === 1 ? setValue("isReportDeliveredPME", true) : setValue("isReportDeliveredPME", false);
        if (visitaTecnicaData.isReadtoclose === 1) {
          if (visitaTecnicaData.isContractedDiag === 1) {
            setValue("isContractedDiag", 1);
          }
          else { setValue("isContractedDiag", 2); }
        }

        reset(visitaTecnicaData);
        setVisitaTecnica(visitaTecnicaData);
        if (visitaTecnicaData.isReadtoclose === 1) {
          setIsReadtoclose(1);
        };
      }
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
    }
  }, [finishReportGenerate]);


  const handleSalvarScrumMaster = async () => {

    startLoading();
    try {
      let retorno;

      if (watch("scrumMasterId") && !watch("tecnicoId")) {
        retorno = (
          await api.http.post("/visitas_tecnicas/scrummaster", {
            processoId: currProcesso.id,
            scrumMasterId: watch("scrumMasterId"),
          })
        ).data;
      }
      else {

        retorno = (
          await api.http.post("/visitas_tecnicas", {
            tecnicoId: watch("tecnicoId"),
            scrumMasterId: watch("scrumMasterId"),
            processoId: currProcesso.id,
          })
        ).data;
      }

      reset(retorno.visitaTecnica);
      setVisitaTecnica(retorno.visitaTecnica);
      selectProcesso(retorno.processo);
      //setExibirScrumMaster(false);
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };



  const actionButtons = () => {

    if (
      user.roleId === "superAdmin" &&
      isProcel &&
      isContractedDiag === 1 &&
      currProcesso.estagio === "preDiagAprovado"
    ) {
      return (
        <Button
          variant="contained"
          color="warning"
          size="large"
          onClick={reprocessarIntegracaoSgt}
          disabled={isSubmitting}
        >
          REPROCESSAR ENVIO AO SGT
        </Button>
      );
    }

    if (isContractedDiag === 2
      && isReadtoclose === 1
      && currProcesso.isFormstep
      && (currProcesso.estagio === 'preDiagAprovado'
        || currProcesso.estagio === 'preDiagIniciado'
        || currProcesso.estagio === 'preDiagReprovado')) {
      return (
        <React.Fragment>
          <Button
            variant="outlined"
            size="large"
            sx={{ mr: 2 }}
            onClick={recusa}
          >
            RECUSAR PARA DIAGNÓSTICO
          </Button>
        </React.Fragment>
      );
    }
    else {
      // console.log("está entrando aqui")
      // console.log("iscontratedDiag: ", isContractedDiag);
      // console.log("isReadtoclose: ", isReadtoclose);
      // console.log("currProcesso: ", currProcesso);
      if (isContractedDiag === 1
        && isReadtoclose === 1
        && currProcesso.isFormstep
        && podeAprovarNoEstado
        && currProcesso.estagio !== 'preDiagAprovado'
        && currProcesso.estagio !== 'diagIniciado'
        && (currProcesso.estagio === 'preDiagIniciado'
          || currProcesso.estagio === 'preDiagReprovado')) {
        return (
          <React.Fragment>
            <Button variant="contained" size="large" onClick={aprova}>
              APROVAR PARA DIAGNÓSTICO
            </Button>
          </React.Fragment>
        );
      }
      else {
        if (
          isDirty ||
          // visitaTecnica ||
          !["preDiagReprovado", "preDiagAprovado", "diagIniciado"].includes(currProcesso.estagio)
        ) {
          return (
            <React.Fragment>
              {user.roleId === "superAdmin" &&
                currProcesso.estagio === "preDiagIniciado" && (
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{ mr: 2 }}
                    onClick={recusa}
                  >
                    RECUSAR PARA DIAGNÓSTICO
                  </Button>
                )}
              <Button
                variant="outlined"
                size="large"
                sx={{ mr: 2 }}
                onClick={cancela}
                disabled={!isDirty || isSubmitting}
              >
                CANCELAR
              </Button>
              <Button
                variant="contained"
                size="large"
                onClick={handleSubmit(salva)}
                disabled={!isDirty || isSubmitting}
              >
                SALVAR
              </Button>
            </React.Fragment>
          );
        } else {
          if (
            user.roleId === "superAdmin"
            && (currProcesso.estagio === "preDiagReprovado")
          ) {
            return (
              <React.Fragment>
                <Button
                  variant="outlined"
                  size="large"
                  sx={{ mr: 2 }}
                  onClick={desfazerRecusa}
                >
                  DESFAZER PROCESSO RECUSADO
                </Button>
              </React.Fragment>
            );
          }
          else {
            if (currProcesso.estagio === "preDiagIniciado") {

              return (
                <React.Fragment>
                  {!currProcesso.isFormstep && (
                    <Button
                      variant="outlined"
                      size="large"
                      sx={{ mr: 2 }}
                      onClick={recusa}
                    >
                      RECUSAR PARA DIAGNÓSTICO
                    </Button>)}
                  {!currProcesso.isFormstep && podeAprovarNoEstado && (
                    <Button variant="contained" size="large" onClick={aprova}>
                      APROVAR PARA DIAGNÓSTICO
                    </Button>)}
                </React.Fragment>
              );
            }
            else if (isDirty
              && user.roleId === "superAdmin"
              // visitaTecnica ||
              //!["preDiagReprovado", "preDiagAprovado", "diagIniciado"].includes(currProcesso.estagio)
            ) {

              return (
                <React.Fragment>
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{ mr: 2 }}
                    onClick={cancela}
                    disabled={!isDirty || isSubmitting}
                  >
                    CANCELAR f
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleSubmit(salva)}
                    disabled={!isDirty || isSubmitting}
                  >
                    SALVAR f
                  </Button>
                </React.Fragment>
              );

            }
          }
        }
      }
    };
  };

  const onConfirmaIsUseGenerateReport = async (data) => {
    setValue("isUseGenerateReport", true);
    setOpenIsUseGenerateReport(false);
  }

  const onNaoConfirmaIsUseGenerateReport = () => {
    setValue("isUseGenerateReport", false);
    setOpenIsUseGenerateReport(false);
  }

  useEffect(() => {
    if (!tecnicoId) {
      setOriginalConsultor(null);
      return;
    }

    const selected = listaConsultores.find((t) => t.id === tecnicoId);
    if (selected) setOriginalConsultor(selected);
  }, [tecnicoId, listaConsultores]);

  useEffect(() => {
    if (!tecnicoVisitaId) {
      setOriginalConsultorVisita(null);
      return;
    }

    const selected = listaTecnicos.find((t) => t.id === tecnicoVisitaId);
    if (selected) setOriginalConsultorVisita(selected);
  }, [tecnicoVisitaId, listaTecnicos]);

  const exibeCorpo = isProcel
    ? (tecnicoId || sgtColaboradorId) && visitaTecnica?.id
    : tecnicoId && visitaTecnica?.id && tecnicoVisitaId && visitaTecnica?.tecnicoVisitaId;

  // Ao salvar a alocação, o pré-diagnóstico começa e o formulário aparece lá embaixo,
  // fora da tela - sobe até ele em vez de deixar a pessoa procurando o que mudou.
  const corpoRef = React.useRef(null);
  const [rolarParaCorpo, setRolarParaCorpo] = React.useState(false);

  React.useEffect(() => {
    if (rolarParaCorpo && exibeCorpo && corpoRef.current) {
      corpoRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setRolarParaCorpo(false);
    }
  }, [rolarParaCorpo, exibeCorpo]);

  const handleClickUseGenerateReport = () => {
    if (!isUseGenerateReport) {
      setOpenIsUseGenerateReport(true);
    }
  };

  useEffect(() => {

    if (listaConsultores.length > 0) {
      const validoTecnico = listaConsultores.some((c) => c.id === tecnicoId);
      setShowWarningTecnico(!validoTecnico);
    }

    if (listaTecnicos.length > 0) {
      const validoVisita = listaTecnicos.some((c) => c.id === tecnicoVisitaId);
      setShowWarningTecnicoVisita(!validoVisita);
    }
  }, [tecnicoId, tecnicoVisitaId, listaConsultores, listaTecnicos, currProcesso.estagio]);

  React.useEffect(() => {
    if (isContractedDiag === 1) {
      setValue("isPMENaoContratou", 0);
    }
  }, [isContractedDiag]);

  const visibleToScrumMaster = () => {
    let exibir = true;
    if (scrumNotApply === 2 && (user.roleId === "superAdmin" || user.roleId === 'gestorSENAI' || user.roleId === 'consultorEE' || user.roleId === 'consultorMercado')) {
      exibir = false;
    }

    if (((user.roleId === "scrumMaster" || user.roleId === 'consultorEE' || user.roleId === 'consultorMercado') && user.id === scrumMasterId) && scrumNotApply === 1) {
      exibir = false;
    }

    if (scrumNotApply === 1 && (user.roleId === "superAdmin" || user.roleId === 'consultorEE' || user.roleId === 'consultorMercado')) {
      exibir = false;
    }
    return exibir;
  }

  return (
    <Paper
      variant="outlined"
      className="center-box no-print"
      sx={{
        textAlign: "center",
        px: 4,
        pt: 2,
        pb: 3,
        maxWidth: "md",
      }}
    >
      <DialogoConfirmacao
        title="Atenção"
        open={openConfirmacao}
        onSim={onSimConfirma}
        onNao={onNaoConfirma}
        criteriosUrl="https://venidera.sharepoint.com/:w:/s/PotencializEE/Eb1F3i4nSM1Es7g5HS2z6E8BeXYpGFXlxvvTCfhwHRDiZA?e=X3DSq0"
      >
        {confirmacaoMsg}
      </DialogoConfirmacao>
      <DialogoConfirmacaoSimples
        title="Atenção"
        open={openConfirmaDesfRecusa}
        onSim={onConfirmaDesfRecusa}
        onNao={onNaoConfirmaDesfRecusa}
      >
        Tem certeza que deseja desfazer recusa do pré-diagnóstico?
      </DialogoConfirmacaoSimples>
      <DialogoConfirmacao
        title="Atenção"
        open={openIsUseGenerateReport}
        onSim={onConfirmaIsUseGenerateReport}
        onNao={onNaoConfirmaIsUseGenerateReport}
      >
        Descreva aqui a justificativa para a não utilização do relatório gerado pelo sistema.
      </DialogoConfirmacao>


      <form onSubmit={handleSubmit(aprova)}>
        <>
          {isProcel && currProcesso?.sgtIntegracaoErro && (
            <Alert severity="error" sx={{ my: 2 }}>
              <strong>Falha ao enviar o atendimento para o SGT:</strong> {currProcesso.sgtIntegracaoErro}
              {currProcesso.sgtIntegracaoErroAt && (
                <>
                  <br />
                  <small>
                    {new Date(currProcesso.sgtIntegracaoErroAt).toLocaleString("pt-BR")}
                  </small>
                </>
              )}
            </Alert>
          )}

          {/* <Divider>
            <h3>Alocação do Especialista Lider do projeto</h3>
          </Divider>
          {!exibeCorpo && (
            <FormControl sx={{ my: 2 }} fullWidth>
              <Select
                field="scrumNotApply"
                useFormRef={useFormRef}
                schema={schema}
                options={opcoesBooleanas}
                disabled={true}
              />
            </FormControl>)}
          <FormControl sx={{ my: 2 }} fullWidth>
            <Select
              field="scrumMasterId"
              useFormRef={useFormRef}
              schema={schema}
              options={listaScrumMasters}
              getOptionLabel={(option) => option.nome}
              disabled={true}
            />
          </FormControl> */}

          {!isProcel && (
            <>
              <Divider>
                <h3>Alocação de especialista de mercado</h3>
              </Divider>
              <FormControl sx={{ my: 2 }} fullWidth>
                {loading ? (
                  <CircularProgress size={24} />
                ) : disabledAlocacao() && !listaTecnicos.some((t) => t.id === originalConsultorVisita?.id) ? (
                  <span>{originalConsultorVisita?.nome}</span>
                ) : (
                  <>
                    <Select
                      field="tecnicoVisitaId"
                      useFormRef={useFormRef}
                      schema={schema}
                      options={listaTecnicos}
                      getOptionLabel={(option) => option.nome}
                      disabled={disabledAlocacao()}
                    />
                    {showWarningTecnicoVisita && (
                      <Alert severity="warning">
                        O técnico responsável: {originalConsultorVisita?.nome} não é um consultor válido. Por favor, selecione outro.
                      </Alert>
                    )}
                  </>
                )}
              </FormControl>
            </>
          )}

          <Divider>
            <h3>{isProcel ? "Alocação de Consultor técnico" : "Alocação de especialista técnico"}</h3>
          </Divider>
          {isProcel ? (
            <>
              <FormControl sx={{ my: 2 }} fullWidth>
                <AsyncAutocomplete
                  label="Estado/Unidade operacional"
                  value={sgtUnidadeFiltro}
                  fetchOptions={fetchSgtUnidades}
                  getOptionLabel={(option) => option?.abreviacao || option?.descricao || ""}
                  noOptionsText={`Nenhuma unidade operacional encontrada para o estado ${currProcesso?.estado || "do processo"}`}
                  disabled={disabledAlocacao()}
                  onChange={(unidade) => {
                    setSgtUnidadeFiltro(unidade || null);
                    setValue("sgtUnidadeId", unidade?.id ?? null, { shouldDirty: true });
                    setValue(
                      "sgtUnidadeNome",
                      unidade?.abreviacao ?? unidade?.descricao ?? null,
                      { shouldDirty: true }
                    );
                    // O consultor escolhido pode não pertencer à nova unidade - limpa
                    // pra evitar ficar com um vínculo de uma unidade que não é mais essa.
                    setValue("sgtColaboradorId", null, { shouldDirty: true });
                    setValue("sgtColaboradorNome", null, { shouldDirty: true });
                    setValue("sgtColaboradorEmail", null, { shouldDirty: true });
                  }}
                />
              </FormControl>
              <FormControl sx={{ my: 2 }} fullWidth>
                {loading ? (
                  <CircularProgress size={24} />
                ) : disabledAlocacao() ? (
                  <span>{sgtColaboradorNome}</span>
                ) : (
                  <AsyncAutocomplete
                    label="Consultor técnico (busca no SGT)"
                    value={sgtColaboradorId ? { id: sgtColaboradorId, nome: sgtColaboradorNome } : null}
                    fetchOptions={fetchSgtColaboradores}
                    getOptionLabel={(option) => option?.nome ?? ""}
                    noOptionsText={
                      sgtUnidadeFiltro
                        ? `Nenhum consultor técnico encontrado para a unidade ${sgtUnidadeFiltro.abreviacao || sgtUnidadeFiltro.descricao || ""}`
                        : "Selecione a unidade operacional primeiro"
                    }
                    disabled={disabledAlocacao()}
                    onChange={(colaborador) => {
                      setValue("sgtColaboradorId", colaborador?.id ?? null, { shouldDirty: true });
                      setValue("sgtColaboradorNome", colaborador?.nome ?? null, { shouldDirty: true });
                      setValue("sgtColaboradorEmail", colaborador?.email ?? null, { shouldDirty: true });
                    }}
                  />
                )}
              </FormControl>
            </>
          ) : (
            <FormControl sx={{ my: 2 }} fullWidth>
              {loading ? (
                <CircularProgress size={24} />
              ) : disabledAlocacao() && !listaConsultores.some((t) => t.id === originalConsultor?.id) ? (
                <span>{originalConsultor?.nome}</span>
              ) : (
                <>
                  <Select
                    field="tecnicoId"
                    useFormRef={useFormRef}
                    schema={schema}
                    options={listaConsultores}
                    getOptionLabel={(option) => option.nome}
                    disabled={disabledAlocacao()}
                  />
                  {showWarningTecnico && tecnicoId && (
                    <Alert severity="warning">
                      O técnico selecionado não é um consultor válido. Por favor, selecione outro.
                    </Alert>
                  )}
                </>
              )}
            </FormControl>
          )}
        </>

        {exibeCorpo && (
          <React.Fragment>
            <div ref={corpoRef} />
            {currProcesso.isFormstep ? (
              <React.Fragment>
                <StepByStepPreDiagnostico2 />
                {/* {visitaTecnica.reportGenerate ? ( */}
                

                <Divider>
                  <h3>{documentoLabel}</h3>
                </Divider>
                {!isProcel && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                    <FormHelperText
                      sx={{
                        m: 0,
                        mt: 0.5,
                        cursor: 'pointer',
                        color: 'primary.main',
                        textAlign: 'center',
                        width: '100%',
                      }}
                      onClick={handleDownloadDeclaracao}
                    >
                      Baixar template da {documentoLabel.toLowerCase()}
                    </FormHelperText>
                  </Box>
                )}
                <FormControl sx={{ my: 2 }} fullWidth>
                  {isProcel ? (
                    <FileField
                      field="preDiagnosticoId"
                      disabled={disabled()}
                      fileData={visitaTecnica?.preDiagnostico}
                      useFormRef={useFormRef}
                      schema={schema}
                    />
                  ) : (
                    <FileField
                      field="certNegDebtTrabId"
                      disabled={disabled()}
                      fileData={currProcesso?.certNegDebtTrab}
                      useFormRef={useFormRef}
                      schema={schema}
                      onUploaded={handleFichaAberturaUploaded}
                    />
                  )}
                </FormControl>

              </React.Fragment>
            ) : (
              <>
                <Divider>
                  <h3>Documentos</h3>
                </Divider>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <FileField
                    field="preDiagnosticoId"
                    disabled={disabled()}
                    fileData={visitaTecnica?.preDiagnostico}
                    useFormRef={useFormRef}
                    schema={schema}
                  />
                </FormControl>
                {!isProcel && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                    <FormHelperText
                      sx={{
                        m: 0,
                        mt: 0.5,
                        cursor: 'pointer',
                        color: 'primary.main',
                        textAlign: 'center',
                        width: '100%',
                      }}
                      onClick={handleDownloadDeclaracao}
                    >
                      Baixar template da {documentoLabel.toLowerCase()}
                    </FormHelperText>
                  </Box>
                )}
                <FormControl sx={{ my: 2 }} fullWidth>
                  <FileField
                    field="certNegDebtTrabId"
                    disabled={disabled()}
                    fileData={currProcesso?.certNegDebtTrab}
                    useFormRef={useFormRef}
                    schema={schema}
                    onUploaded={handleFichaAberturaUploaded}
                  />
                </FormControl>
              </>
            )}

            {currProcesso && (programaInovacao || currProcesso.estagio != "preDiagIniciado") && (
              <React.Fragment>
                <Divider>
                  <h3>
                    Observações de{" "}
                    {currProcesso.estagio == "preDiagReprovado"
                      ? "reprovação"
                      : "aprovação"}
                  </h3>
                </Divider>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <TextField
                    {...register("observacoes")}
                    multiline
                    rows={4}
                    disabled={!podeEditarObservacoes}
                  />
                </FormControl>
              </React.Fragment>
            )}
            {podeExibirApresentacaoPME ? (
                  <>
                    <Divider>
                      <h3>Apresentação para o PME</h3>
                    </Divider>
                    {!isProcel && (
                      <Box sx={{ width: '100%', marginTop: '20px' }}>
                        <FormControl sx={{ mb: 2 }}>
                          <Checkbox
                            field="isUseGenerateReport"
                            disabled={disabled()}
                            schema={schema}
                            useFormRef={useFormRef}
                            onClick={handleClickUseGenerateReport}
                          />
                        </FormControl>
                      </Box>
                    )}

                    {(!isProcel && visitaTecnica?.reportGenerate
                      && isUseGenerateReport) && (
                        <FormControl sx={{ mb: 2 }} fullWidth>
                          <FileField
                            field="relatorioId"
                            fileData={visitaTecnica?.relatorio || null}
                            useFormRef={useFormRef}
                            schema={schema}
                            disabled={disabled()}
                          />
                        </FormControl>
                      )}
                    {(visitaTecnica?.reportGenerate || finishReportGenerate) && (
                      <Box sx={{ width: '100%', marginTop: '20px' }}>
                        <FormControl sx={{ mb: 2 }}>
                          <Checkbox
                            field="isReportDeliveredPME"
                            label={isProcel ? "Pré-diagnóstico entregue a empresa" : undefined}
                            schema={schema}
                            useFormRef={useFormRef}
                            disabled={disabled()}
                          />
                        </FormControl>
                      </Box>
                    )}

                    {(
                      visitaTecnica?.reportGenerate &&
                      isReportDeliveredPME) ? (
                      <Box sx={{ width: '100%', marginTop: '20px', justifyContent: "center", justifyItems: "center" }}>
                        {isProcel && (
                          <span style={{ display: 'block', marginBottom: 8 }}>
                            A empresa segue para etapa de Diagnóstico?
                          </span>
                        )}
                        <FormControl sx={{ my: 2 }} fullWidth>
                          <Select
                            field="isContractedDiag"
                            useFormRef={useFormRef}
                            schema={schema}
                            options={
                              isProcel
                                ? selecionarPMEVaiContratarDiagnostico.map((opcao) =>
                                    opcao.id === 1
                                      ? { ...opcao, label: "SIM" }
                                      : opcao.id === 2
                                      ? { ...opcao, label: "NÃO: o projeto permanece no M&A como pré-diagnóstico reprovado" }
                                      : opcao
                                  )
                                : selecionarPMEVaiContratarDiagnostico
                            }
                            getOptionLabel={(option) => option.label}
                            disabled={isReadtoclose === 1}
                          />
                        </FormControl>
                      </Box>
                    ) : null}

                    {(visitaTecnica?.reportGenerate
                      && isContractedDiag === 2
                      && isReportDeliveredPME) && (
                        <FormControl sx={{ my: 2 }} fullWidth>
                          <Select
                            field="isPMENaoContratou"
                            useFormRef={useFormRef}
                            schema={schema}
                            options={motivosPMENaoContratarDiagnostico}
                            getOptionLabel={(option) => option.label}
                            disabled={isReadtoclose === 1}
                          />
                        </FormControl>
                      )}
                  </>) : null}
          </React.Fragment>
        )}

        {isProcel && (
          <PropostaComercialSection
            processoId={currProcesso.id}
            podeEditarProposta={
              ["superAdmin", "gestorSENAI"].includes(user.roleId) ||
              (["consultorEE", "consultorMercado"].includes(user.roleId) &&
                Number(currProcesso?.interlocutorMercadoId) === Number(user.id)) ||
              (user.roleId === "consultorEE" &&
                Boolean(user.email) &&
                Boolean(sgtColaboradorEmail) &&
                user.email.trim().toLowerCase() === sgtColaboradorEmail.trim().toLowerCase())
            }
            podeValidarDR={
              user.roleId === "superAdmin" ||
              (user.roleId === "gestorSENAI" &&
                Boolean(user.uf) &&
                Boolean(currProcesso?.estado) &&
                (user.uf.trim().toUpperCase() === UF_TODOS ||
                  normalizarEstado(user.uf) === normalizarEstado(currProcesso.estado)))
            }
            cartaoCnpj={currProcesso.cartaoCnpj}
            onCartaoCnpjAtualizado={(processoAtualizado) => selectProcesso(processoAtualizado)}
            autodeclaracao={currProcesso.certNegDebtTrab}
            onAutodeclaracaoAtualizada={(processoAtualizado) => selectProcesso(processoAtualizado)}
          />
        )}

        <Timestamps dados={visitaTecnica} />

        {/* {!disabled() && exibirScrumMaster && ( */}
        {/* {!disabled() && ( */}
        {/* {currProcesso.scrumNotApply > 0 && ( */}
        <Box sx={{ mt: 3, textAlign: "center" }}>{actionButtons()}</Box>
        {/* )} */}
      </form>
    </Paper >
  );
};

export default VisitaTecnica;
